import {Injectable} from '@angular/core';
import {
  ALLOTMENT_TYPE,
  APARTMENT_TYPE,
  CORPORATE_SLABS_TYPE,
  FLAT_TYPE, HALL_TYPE,
  HOTEL_TYPE,
  HOUSE_TYPE, MALL_TYPE, ROOM_TYPE, RURAL_TYPE,
  SHED_TYPE, TERRAIN_TYPE
} from './const/property-type';
import {PropertyFilterGroup} from './model/property-type-group.model';
import { FeatureToggleService } from 'src/app/core/toggle/feature-toggle.service';
import { toKebabCase } from 'src/app/core/helpers/string.healper';

@Injectable({
  providedIn: 'root'
})
export class SearchFilterService {

  theme: string;

  constructor(public toggleService: FeatureToggleService) {}

  getPropertyTypes(): PropertyFilterGroup[] {
    return this.theme === 'campaign_search' ? this.getCampaignSearchFilters() : this.getSearchFilters();
  }

  getCampaignSearchFilters(): PropertyFilterGroup[] {
    return [
      {
        groupName: 'Casa',
        options: this.toggleService.isActive('toggle_view_sobrado') ? HOUSE_TYPE : HOUSE_TYPE.filter(value => value.label !== 'Sobrado')
      },
      {
        groupName: 'Apartamento',
        options: APARTMENT_TYPE
      },
      {
        groupName: 'Flat',
        options: FLAT_TYPE
      }
    ].map(v => ({...v, options: v.options.map(o => ({...o, value: toKebabCase(o.value)}))}));
  }

  getSearchFilters(): PropertyFilterGroup[] {
    return [
      {
        groupName: 'Casa',
        options: this.toggleService.isActive('toggle_view_sobrado') ? HOUSE_TYPE : HOUSE_TYPE.filter(value => value.label !== 'Sobrado')
      },
      {
        groupName: 'Apartamento',
        options: APARTMENT_TYPE
      },
      {
        groupName: 'Flat',
        options: FLAT_TYPE
      },
      {
        groupName: 'Galpão',
        options: SHED_TYPE
      },
      {
        groupName: 'Hotel',
        options: HOTEL_TYPE
      },
      {
        groupName: 'Lajes corporativas',
        options: CORPORATE_SLABS_TYPE
      },
      {
        groupName: 'Loteamento',
        options: ALLOTMENT_TYPE
      },
      {
        groupName: 'Mall',
        options: MALL_TYPE
      },
      {
        groupName: 'Rural',
        options: RURAL_TYPE
      },
      {
        groupName: 'Salão',
        options: HALL_TYPE
      },
      {
        groupName: 'Salas',
        options: ROOM_TYPE
      },
      {
        groupName: 'Terreno',
        options: TERRAIN_TYPE
      }
    ].map(v => ({...v, options: v.options.map(o => ({...o, value: toKebabCase(o.value)}))}));
  }
}
